import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
import {
  categoryController, subCategoryController, brandController,
  unitController, productController, warehouseController,
  locationController, supplierController, purchaseOrderController,
  purchaseReturnController, stockInController, stockOutController,
  stockTransferController, stockAdjustmentController,
  stockController, reportController,
} from '../../controllers/inventoryController';
import ActionBtns from './ActionBtns';
import FormModal from './FormModal';

import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
// ─────────────────────────────────────────────────────────────────────────────
// 4. UNITS OF MEASURE PAGE
// ─────────────────────────────────────────────────────────────────────────────
export const UnitsPage = ({ companyId }) => {
  const crud = useCRUD(unitController, companyId);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [saving, setSaving]     = useState(false);
  const [form, setForm]         = useState({ name:'',shortName:'',type:'Quantity',baseUnit:'',conversionFactor:1,status:'Active' });
  const set = (k,v) => setForm(p=>({...p,[k]:v}));
  const [errors, setErrors] = useState([]);

  const openAdd  = () => { setEditItem(null); setForm({ name:'',shortName:'',type:'Quantity',baseUnit:'',conversionFactor:1,status:'Active' }); setErrors([]); setShowForm(true); };
  const openEdit = (r) => { setEditItem(r); setForm({...r}); setErrors([]); setShowForm(true); };

  const handleSave = async () => {
    setSaving(true); setErrors([]);
    const res = editItem ? await unitController.update(editItem.id,{...form,companyId}) : await unitController.create({...form,companyId});
    setSaving(false);
    if (res.success) { crud.show(res.message); setShowForm(false); crud.fetchAll(); }
    else setErrors(res.errors?.length?res.errors:[res.message]);
  };

  const columns = [
    { label:'Unit Name', key:'name', render: v => <div style={{ fontWeight:700 }}>{v}</div> },
    { label:'Short Name', key:'shortName', render: v => <Badge color={C.teal} bg={`${C.teal}15`}>{v}</Badge> },
    { label:'Type', key:'type', render: v => v||'—' },
    { label:'Base Unit', key:'baseUnit', render: v => v||'—' },
    { label:'Conv. Factor', key:'conversionFactor', render: v => v||1 },
    { label:'Status', key:'status', render: v => <StatusBadge status={v}/> },
    { label:'', key:'actions', render:(_, r) => <ActionBtns onEdit={()=>openEdit(r)} onDelete={()=>crud.handleDelete(r.id,`"${r.name}"`)} /> },
  ];

  return (
    <div style={S.page}>
      {crud.ToastEl}{crud.Dialog}
      <PageHeader title="Units of Measure" subtitle="Manage measurement units" Icon={Settings} color={C.teal}
        action={<button style={S.btnPri} onClick={openAdd}><Plus size={15}/> Add Unit</button>} />
      <div style={S.card}>
        <div style={{ padding:'14px 14px 0' }}>
          <FilterBar search={crud.search} onSearch={crud.setSearch}
            filters={[{ key:'type', value:crud.filters.type||'All', onChange:v=>crud.setFilters(p=>({...p,type:v==='All'?'':v})),
              options:[{value:'All',label:'All Types'},...['Quantity','Weight','Volume','Length','Area','Time'].map(t=>({value:t,label:t}))] }]} />
        </div>
        <DataTable columns={columns} data={crud.data} loading={crud.loading} emptyTitle="No units found"
          page={crud.page} totalPages={crud.totalPages} onPageChange={crud.setPage} total={crud.total} />
      </div>
      {showForm && (
        <FormModal title={editItem?'Edit Unit':'Add Unit'} onClose={()=>setShowForm(false)} onSave={handleSave} saving={saving}>
          <ErrList errors={errors} />
          <FormGrid>
            <FormField label="Unit Name *"><input style={S.input} value={form.name} onChange={e=>set('name',e.target.value)} placeholder="e.g. Kilogram" /></FormField>
            <FormField label="Short Name *"><input style={S.input} value={form.shortName} onChange={e=>set('shortName',e.target.value)} placeholder="e.g. kg" /></FormField>
            <FormField label="Type">
              <select style={S.select} value={form.type} onChange={e=>set('type',e.target.value)}>
                {['Quantity','Weight','Volume','Length','Area','Time'].map(t=><option key={t}>{t}</option>)}
              </select>
            </FormField>
            <FormField label="Base Unit"><input style={S.input} value={form.baseUnit} onChange={e=>set('baseUnit',e.target.value)} placeholder="e.g. gram" /></FormField>
            <FormField label="Conversion Factor"><input type="number" step="0.001" style={S.input} value={form.conversionFactor} onChange={e=>set('conversionFactor',e.target.value)} /></FormField>
            <FormField label="Status"><select style={S.select} value={form.status} onChange={e=>set('status',e.target.value)}><option>Active</option><option>Inactive</option></select></FormField>
          </FormGrid>
        </FormModal>
      )}
    </div>
  );
};
export default UnitsPage;